import { StatusErrorPage } from '@/pages/_error'

const ServerErrorPage = () => <StatusErrorPage statusCode={500} />

export default ServerErrorPage
